<template>
    <div>
      <div v-if="schema.type === 'object'" class="nested-section">
        <h3 :style="{ fontSize: getFontSize }">{{ key_to_show }}</h3> <i v-if="intern_key!=key_to_show"> {{intern_key}}</i>
        <template v-for="(value, key) in schema.properties">
          <div class="nested-section" :style="{ marginLeft: depth * 20 + 'px' }">
            <RecursivePayloadOnSchemaEditorTuned
              :schema="value"
              v-model="data_payload[key]"
              :key_to_show="get_next_key_to_show(key, value)"
              :intern_key="key"
              :depth="depth + 1"
              :readonly="readonly"
              :available_e_types="available_e_types"
              @input="(new_data) => update_payload(key, new_data)"
            />
          </div>
        </template>
        <template v-for="key in out_of_schema_keys"> 
          <div class="nested-section" :style="{ marginLeft: depth * 20 + 'px' }">
            <v-row>
              <v-col cols="4">
                <p :style="{ fontSize: nextFontSize, color:'red'}"><strong>{{ key }}:</strong></p>
              </v-col>
              <v-col cols="7">
                <!-- Idealmente mostrar con componente recursivo de json -->
                <p :style="{ fontSize: nextFontSize , color:'red' } ">{{data_payload[key]}}</p>
              </v-col>
              <v-col cols="1" v-if="!readonly">
                
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="delete_extra_key(key)"
                      icon
                      color="red"
                      v-bind="attrs"
                      v-on="on"        
                      >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                   </template>
                   <span>Eliminar campo (no consta en esquema de registro)</span>
                </v-tooltip>
              </v-col>
            </v-row>  
  
            
          </div>  
        </template>
  
  
  
      </div>
      <div v-else-if="schema.type === 'array'" class="nested-section">
        <h3 :style="{ fontSize: getFontSize }">{{ key_to_show }}</h3><i v-if="intern_key!=key_to_show"> {{intern_key}}</i>
        <div v-if="!is_tablable(schema.items)">
          <ListOnSchemaEditorTuned
          :item_schema="schema.items"
          :available_e_types="available_e_types"
          v-model="data_payload"
          :readonly="readonly"
          :depth="depth + 1"
          @change="payloadChanged"/>
        </div>
        <div v-else>
          <GenericTableComponent
            :data="data_payload" :headers="Object.keys(schema.items.properties)"></GenericTableComponent>
        </div>
      </div>
      <div v-else class="nested-section">
        <v-row class="d-flex align-baseline">
          <v-col cols="3">
            <p :style="{ fontSize: getFontSize }"><strong>{{ key_to_show }}:</strong></p>
          </v-col>
          <v-col cols="8">
            <template v-if="schema.type === 'boolean'">
                <v-checkbox
                    v-model="data_payload"
                    @change="payloadChanged"
                    :label="intern_key"
                    :readonly="readonly"
                    hide-details="auto"
                />
            </template>
            <template v-else-if="schema.type === 'string'">
                <v-tooltip top v-if="intern_key.includes('entity_type')">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" style="display: inline-block; width: 100%">
                        <v-select
                          v-model="data_payload"
                          :items="available_e_types"
                          :label="intern_key"
                          @input="payloadChanged"
                          item-text="name"
                          item-value="uuid"
                          outlined
                          hide-details="auto"
                        />
                      </div>
                    </template>
                    <span style="max-width: 350px; white-space: normal; display: block;" v-if="data_payload">
                        {{available_e_types.find(t => t.uuid === data_payload).schema}}
                      </span>
                </v-tooltip>
                <WackScriptEditor
                    v-else-if="intern_key.includes('_script')"
                    v-model="data_payload"
                    @input="payloadChanged"
                ></WackScriptEditor>
                <v-text-field
                    v-else
                    v-model="data_payload"
                    @input="payloadChanged"
                    :label="intern_key"
                    :readonly="readonly"
                    outlined
                    dense
                    hide-details="auto"
                    />
               
            </template>
            <template v-else-if="schema.type === 'number' || schema.type === 'integer'">
                <v-text-field
                v-model="data_payload"
                :label="intern_key"
                @input="turnIntoNumber"
                :readonly="readonly"
                outlined
                dense
                type="number"
                hide-details="auto"
                />
            </template>
            <template v-else-if="typeof schema === 'object' && Object.keys(schema).length === 0">
                <div>
                    {{ data_payload}}   
                </div>
           
            </template>
          </v-col>
        </v-row>
      </div>
    </div>
  </template>
    
  <script>
  import GenericTableComponent from '@/components/GenericTableComponent.vue'
  import ListOnSchemaEditorTuned from '@/modules/entities/infra/ListOnSchemaEditorTuned.vue'
  import WackScriptEditor from "@/modules/document/infra/WackScriptEditor";
  
  export default {
      name: "RecursivePayloadOnSchemaEditorTuned",
      components: {
        GenericTableComponent,
        ListOnSchemaEditorTuned,
        WackScriptEditor
      },
      data() {
        return {
          data_payload: this.value !== null ? this.value : this.getDefaultPayload(),
        }
      },
      props: {
        schema: {
          type: Object,
          required: true,
        },
        key_to_show: {
          type: String,
          required: false,
          default: null,
        },
        intern_key: {
          type: String,
          required: false,
          default: null,
        },
        value: {
          type: [Object, Array, String, Number, Boolean],
          required: false,
          default:null,
        },
        depth: {
          type: Number,
          default: 0,
        },
        readonly: {
          type: Boolean,
          default: false,
        },
        available_e_types: {
          type: Array,
          default: () => []
        }
      },
      mounted() {
        // let init_payload = null
        // if(this.value){
        //   init_payload = this.value;
        // }else{
        //   if(this.schema.type === 'object'){
        //     init_payload = {}
        //   }else if(this.schema.type === 'array'){
        //     init_payload = []
        //   }
        //   else if(this.schema.type === 'string'){
        //     init_payload = ''
        //   }else{
        //     init_payload = null
        //   }
        // }
        // this.data_payload = init_payload;
        this.initializePayload();
        
      },
      computed: {
          
          getFontSize() {
              const baseSize = 20; // Base font size in pixels
              const sizeIncrement = 2; // Increment in pixels for each depth level
              return `${baseSize - this.depth * sizeIncrement}px`; // Decrease font size as depth increases
          },
          nextFontSize() {
              const baseSize = 20; // Base font size in pixels
              const sizeIncrement = 2; // Increment in pixels for each depth level
              return `${baseSize - (this.depth + 1) * sizeIncrement}px`; // Decrease font size as depth increases
          },
          out_of_schema_keys(){
            if (this.schema.type !== 'object') {
              return [];
            }
            return Object.keys(this.data_payload).filter(key => !Object.keys(this.schema.properties).includes(key));
          }
      },
      methods: {
        turnIntoNumber(value) {
          this.data_payload = value !== '' ? Number(value) : null;
          this.payloadChanged(); // Ensure this is still called
        },
        is_tablable(schema){
            if(schema.type === 'object' && this.readonly ){
              // for(const key in schema.properties){
              //   if(schema.properties[key].type === 'object' || schema.properties[key].type === 'array'){
              //     return false
              //   }
              // }
              return true
            }
            else{
              return false
            }
        },
  
        get_next_key_to_show(key, value) {
          if(value.title){
            return value.title;
          }
          return key;
        },
        getDefaultPayload() {
        if (this.schema.type === 'object') {
          return {};
        } else if (this.schema.type === 'array') {
          return [];
        } else if (this.schema.type === 'string') {
          return '';
        } else {
          return null;
        }
      },
      delete_extra_key(key){
        console.log('delete_extra_key', key);
        const new_payload = {...this.data_payload};
        delete new_payload[key];
        this.data_payload = new_payload;
        this.payloadChanged();
      },
      initializePayload() {
        if (this.value === null) {
          this.data_payload = this.getDefaultPayload();
        } else {
          this.data_payload = this.value;
        }
      },
        payloadChanged(){
          console.log('payload changed', this.key_to_show, this.data_payload);
          this.$emit('input', this.data_payload);
        },
        update_payload(key, value){
          console.log('update_payload', key, value);
          this.data_payload = {
            ...this.data_payload,
            [key]: value
          }
          this.payloadChanged();
        }
  
      },
      
    };
    </script>
    
    <style scoped>
    .nested-section {
      padding-left: 10px;
      /*border-left: 1px solid #ccc; */
      margin-top: 10px;
    }
    </style>
    